import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import YouTube from 'react-youtube';

// Componente do player de YouTube
const YoutubePlayer = () => {
  const [playerReady, setPlayerReady] = useState(false);
  const [playlistId, setPlaylistId] = useState('PLRDNddkJ9BTDGn6IpkvFewfv3cnWlOJlP');
  const [player, setPlayer] = useState(null);
  const playerRef = useRef(null);
  
  // Carregar configurações salvas
  useEffect(() => {
    const savedConfig = localStorage.getItem('painelChamada_configCompleta');
    if (savedConfig) {
      try {
        const config = JSON.parse(savedConfig);
        if (config.youtube && config.youtube.playlistId) {
          setPlaylistId(config.youtube.playlistId);
        }
      } catch (error) {
        console.error('Erro ao carregar configurações da playlist:', error);
      }
    }
  }, []);

  // Adicionar efeito para reiniciar a playlist quando o player estiver pronto
  useEffect(() => {
    if (player) {
      // Garante que o player reinicie a playlist quando ela terminar
      const interval = setInterval(() => {
        // Verifica se o player está inativo (a playlist terminou)
        if (player.getPlayerState() === YouTube.PlayerState.ENDED) {
          console.log('Playlist terminou, reiniciando...');
          player.playVideoAt(0); // Reinicia a playlist do primeiro vídeo
        }
      }, 5000); // Verifica a cada 5 segundos

      return () => clearInterval(interval);
    }
  }, [player]);
  
  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      mute: 1,
      controls: 0,
      showinfo: 0,
      rel: 0,
      listType: 'playlist',
      list: playlistId,
      loop: 1, // Tenta ativar o loop (nem sempre funciona com playlists)
      playlist: playlistId // Necessário para loop funcionar
    },
  };

  const handleReady = (event) => {
    setPlayerReady(true);
    setPlayer(event.target);
    playerRef.current = event.target;
  };

  // Manipulador para quando a playlist terminar
  const handleEnd = (event) => {
    console.log('Playlist terminou, reiniciando manualmente...');
    if (playerRef.current) {
      playerRef.current.playVideoAt(0);
    }
  };

  return (
    <Box sx={{ 
      width: '100%',
      position: 'relative',
      aspectRatio: '16 / 9',
      overflow: 'hidden'
    }}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
      }}>
        <YouTube 
          opts={opts}
          style={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%', 
            height: '100%' 
          }}
          onReady={handleReady}
          onEnd={handleEnd}
          className="youtube-player"
        />
      </Box>
    </Box>
  );
};

export default YoutubePlayer; 